module.exports = __webpack_public_path__ + "static/img/lgs.031f7cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lgs.png
// module id = NWv5
// module chunks = 0